import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TegelModule } from '@scania/tegel-angular-17';
import { DeskPopoverComponent } from '../../desk-popover/desk-popover.component';
import { ReservationListComponent } from '../../reservation-list/reservation-list.component';
import { BuildingAdminComponent } from '../../../admin/building-admin/building-admin.component';
import { P2830_DESKS, P2830_DESKS_6TH } from '../shared/constants/p28-30.desks';
import { BuildingReservationsBase } from '../shared/reservation-base';

@Component({
  selector: 'app-p28-30',
  imports: [ReservationListComponent, TegelModule, DeskPopoverComponent, BuildingAdminComponent, CommonModule],
  templateUrl: './p28-30.component.html',
  styleUrl: './p28-30.component.scss'
})
export class P2830Component extends BuildingReservationsBase {
  public readonly desks = P2830_DESKS;
  public readonly desks6th = P2830_DESKS_6TH;
}